import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {UsuariosCargosModel} from "./usuarios-cargos.model";
import { UsuariosCargosService } from './usuarios-cargos.service';
import {Funcoes} from "../funcoes";
import {PaisesService} from "../paises/paises.service";


@Component({
  selector: 'app-usuarios-cargos-form',
  templateUrl: './usuarios-cargos-form.component.html'
})
export class UsuariosCargosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  cargo: UsuariosCargosModel = new UsuariosCargosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private usuariosCargosService: UsuariosCargosService,
    private paisesService: PaisesService,
    private _location: Location,
    public func: Funcoes
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      editar: [],
      consultar: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_cargo'];

      if(!this.pageIsUpd && !this.pageIsAdd){
        this.title = this.func.traduzir('front.visualizarTipoAcesso');
      }else if(this.pageIsUpd){
        this.title = this.func.traduzir('front.editarTipoAcesso');
      }else{
        this.title = this.func.traduzir('front.addTipoAcesso');
      }


      if (!id) {

        // busca acoes do sistema
        this.usuariosCargosService.getAcoes().subscribe(json => {

            let p = json.Payload;

            for(let i in p){
              p[i]['acao'] = [this.func.cloneObj(p[i])];
              p[i]['id_acao'] = p[i]['id'];
              delete p[i]['id'];
              delete p[i]['nome'];

              p[i]['editar'] = false;
              p[i]['consultar'] = true;
            }
            this.cargo['privilegios_acoes'] = p;

          },
          error => {
            this.func.showErro(error.json());
          });

        return;
      }

      this.usuariosCargosService.getAcoesByIdCargo(id)
        .subscribe(json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarTipoAcesso')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarTipoAcesso')+': '+json.Payload[0].nome;
            }
            this.cargo = json.Payload[0];

          },
          error => {
            this.func.showErro(error.json());
          });

    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
    // values = this.form.value;
      values = this.cargo;

    if (values.id) {
      result = this.usuariosCargosService.editar(values, values.id);
    } else {
      result = this.usuariosCargosService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'usuarios', 'tipos-acesso']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/usuarios-cargos/usuarios-cargos-form.component.ts